// import React, { useEffect, useState } from "react"
// import Select from "react-select"
// import { Controller } from "react-hook-form"
// import { getGroupList } from "../../../services/Inventory/inventory"

// function ucfirst(str) {
//   var firstLetter = str.substr(0, 1)
//   return firstLetter.toUpperCase() + str.substr(1)
// }

// const Group = ({ control, name, onSelectChange, target, placeholder }) => {
//   const [isLoading, setIsLoading] = useState(true)
//   const [fetchResponse, setFetchResponse] = useState([])

//   const loadOptions = async () => {
//     const data = await getGroupList()
//     setIsLoading(false)
//     const response = data?.data?.map(dta => {
//       return {
//         label: dta?.description && ucfirst(dta.description),
//         value: dta.id,
//         ...dta,
//       }
//     })

//     setFetchResponse(response)
//   }

//   useEffect(() => {
//     loadOptions()
//   }, [])

//   return (
//     <div>
//       <Controller
//         name={name}
//         control={control}
//         render={({ field: { onChange, ref, value } }) => {
//           return (
//             <Select
//               options={fetchResponse}
//               placeholder={placeholder ? placeholder : "Select"}
//               isLoading={isLoading}
//               inputRef={ref}
//               onChange={e => {
//                 onChange(e)
//                 if (onSelectChange) onSelectChange(e)
//               }}
//               value={value}
//               classNamePrefix="react-select"
//               className="elevate-dropdown"
//               menuPortalTarget={document.querySelector(
//                 target ? target : ".modal"
//               )}
//             />
//           )
//         }}
//       />
//     </div>
//   )
// }

// export default Group

import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getGroupList } from "../../../services/Inventory/inventory"

// Type mapping for group headings
const typeMap = {
  1: "Material",
  2: "Fittings",
  3: "Consumables",
}

function ucfirst(str) {
  var firstLetter = str?.substr(0, 1) || ""
  return firstLetter.toUpperCase() + (str?.substr(1) || "")
}

const Group = ({ control, name, onSelectChange, target, placeholder }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  const loadOptions = async () => {
    const data = await getGroupList()
    setIsLoading(false)

    // Grouping data by type_id
    const groupedData = data?.data?.reduce((acc, item) => {
      const groupLabel = typeMap[item.type_id] || "Others"
      if (!acc[groupLabel]) acc[groupLabel] = []
      acc[groupLabel].push({
        label: item?.description && ucfirst(item.description),
        value: item.id,
        ...item,
      })
      return acc
    }, {})

    // Convert object to react-select's grouped format
    const groupedOptions = Object.keys(groupedData).map(groupLabel => ({
      label: groupLabel,
      options: groupedData[groupLabel],
    }))

    setFetchResponse(groupedOptions)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => (
          <Select
            options={fetchResponse}
            // placeholder={placeholder || "Select"}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
            isLoading={isLoading}
            inputRef={ref}
            onChange={e => {
              onChange(e)
              if (onSelectChange) onSelectChange(e)
            }}
            value={value}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            // menuPortalTarget={document.querySelector(target || ".modal")}
            menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          />
        )}
      />
    </div>
  )
}

export default Group
